import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import Select from 'react-select'
import axios from 'axios'

function AddTopic({ onClose, onSuccess }) {
  const [selectedOption, setSelectedOption] = useState(null)
  const options = [
    { value: 'English', label: 'English' },
    { value: 'Math', label: 'Math' },
    { value: 'Reading', label: 'Reading' },
    { value: 'Science', label: 'Science' },
    // Add more options as needed
  ]

  const [data, setData] = useState([])
  const [selectedOption2, setSelectedOption2] = useState('')

  useEffect(() => {
    getTopics()
  }, []) // Empty dependency array means this effect runs only once when the component mounts
  const getTopics = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getallacttopics`
    )
    if (response.status === 200) {
      setData(response.data)
    }
  }
  const handleSelectChange2 = (event) => {
    setSelectedOption2(event.target.value)
  }

  function handleSelectChange(selectedOption) {
    setSelectedOption(selectedOption)
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm()

  const generateError = (err) =>
    toast.error(err, {
      position: 'top-center',
    })

  const onSubmit = async (values) => {
    if (!selectedOption) {
      generateError('Topic Type is required')
      return
    }
    if (!selectedOption2) {
      generateError('Select Topic is required')
      return
    }
    try {
      const { data: resp } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}saveactsubtopic`,
        {
          ...values,
          id: 0,
          topic_type: selectedOption.value,
          topic_id: selectedOption2,
        },
        {
          withCredentials: true,
        }
      )

      if (resp) {
        if (resp.errors) {
          const { topic_code, topic_title, topic_type } = resp.errors
          if (topic_code) generateError(topic_code)
          else if (topic_title) generateError(topic_title)
          else if (topic_type) generateError(topic_type)
        } else {
          toast.success('Sub Topic added successfully')
          if (onSuccess) onSuccess()
          if (onClose) onClose()
          reset()
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div
      className="font-sans p-8 rounded-[20px] bg-white shadow-2xl w-full max-w-2xl mx-auto"
      style={{ minWidth: 350 }}
    >
      <h4 className="text-[#030303] font-bold text-xl pb-6">
        Add ACT Sub Topic
      </h4>
      <form className="" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="grid grid-cols-2 gap-x-6 gap-y-4 pt-2">
          <div>
            <label className="block text-[#535862] font-medium mb-1">
              Topic Code <span className="text-[#DE3C7D]">*</span>
            </label>
            <input
              type="text"
              name="topic_code"
              className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
              {...register('topic_code', {
                required: 'Topic Code is required',
              })}
            />
            {errors.topic_code && (
              <p className="text-[#DE3C7D] text-xs mt-1">
                {errors.topic_code.message}
              </p>
            )}
          </div>
          <div>
            <label className="block text-[#535862] font-medium mb-1">
              Topic Title <span className="text-[#DE3C7D]">*</span>
            </label>
            <input
              type="text"
              name="topic_title"
              className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
              {...register('topic_title', {
                required: 'Topic Title is required',
              })}
            />
            {errors.topic_title && (
              <p className="text-[#DE3C7D] text-xs mt-1">
                {errors.topic_title.message}
              </p>
            )}
          </div>
          <div>
            <label className="block text-[#535862] font-medium mb-1">
              Topic Type <span className="text-[#DE3C7D]">*</span>
            </label>
            <Select
              options={options}
              value={selectedOption}
              onChange={handleSelectChange}
              classNamePrefix="react-select"
              placeholder="Select type..."
            />
            {!selectedOption && (
              <p className="text-[#DE3C7D] text-xs mt-1">
                Topic Type is required
              </p>
            )}
          </div>
          <div>
            <label className="block text-[#535862] font-medium mb-1">
              Select Topic <span className="text-[#DE3C7D]">*</span>
            </label>
            <select
              className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
              value={selectedOption2}
              onChange={handleSelectChange2}
            >
              <option value="">Select Topic</option>
              {data.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.topic_title}
                </option>
              ))}
            </select>
            {!selectedOption2 && (
              <p className="text-[#DE3C7D] text-xs mt-1">
                Select Topic is required
              </p>
            )}
          </div>
        </div>
        <div className="flex justify-start gap-3 mt-8">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-md border border-[#F0F0F0] text-[#535862] bg-white hover:bg-neutral-50 transition-colors font-medium"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 rounded-md bg-[#DE3C7D] text-white font-medium hover:bg-[#c8356f] transition-colors"
          >
            Submit
          </button>
        </div>
      </form>
      <ToastContainer />
    </div>
  )
}

export default AddTopic
